<template>
  <Dialog
    :visible.sync="localVisible"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="upload-document-modal"
    @close="$emit('close')"
  >
    <template slot="title">
      <div class="modal-header-content">
        <div class="modal-title-group">
          <span class="modal-title">Upload Document</span>
          <span class="modal-subtitle">{{ destination && destination.name }}</span>
        </div>
      </div>
    </template>

    <div class="modal-body">
      <div class="doc-type-section">
        <p class="doc-type-label">Document Type</p>
        <div class="type-pills">
          <span
            v-for="type in availableTypes"
            :key="type.value"
            class="type-pill"
            :class="{ active: selectedType === type.value }"
            @click="selectedType = type.value"
          >
            {{ type.label }}
          </span>
        </div>
      </div>

      <div class="upload-section">
        <p class="upload-label">UPLOAD YOUR FILE</p>
        <div
          class="upload-area"
          @click="$refs.fileInput.click()"
          @dragover.prevent
          @drop.prevent="onDrop"
        >
          <input ref="fileInput" type="file" style="display:none" @change="onInputChange" />
          <div class="upload-inner">
            <i class="el-icon-upload2" />
            <p class="browse-text">Browse Files</p>
            <p class="drag-text">Drag and drop the file here</p>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import './UploadDocumentModal.scss';

export default {
  name: 'UploadDocumentModal',
  props: {
    visible:     { type: Boolean, required: true },
    destination: { type: Object,  required: true },
    indentNo:    { type: String,  required: true },
    movement:    { type: String,  required: true },
  },
  data() {
    return {
      localVisible: false,
      selectedType: 'lr',
      uploading: false,
    };
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val) this.selectedType = 'lr';
    },
    localVisible(val) {
      if (!val) this.$emit('close');
    },
  },
  computed: {
    documentTypeValue() {
      const map = { lr: 1, pod: 2, others: 3 };
      return map[this.selectedType] || 1;
    },
    availableTypes() {
      return [
        { value: 'lr',     label: 'LR Document', show: this.$hasPermission(`transporter_add_elr_attachments_${this.movement}`) },
        { value: 'pod',    label: 'POD',          show: this.$hasPermission(`transporter_add_pod_attachments_${this.movement}`) },
        { value: 'others', label: 'Others',       show: this.$hasPermission('indent_view_other_attachment') },
      ].filter(t => t.show);
    },
  },
  methods: {
    onDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file) this.handleFileChange(file);
    },
    onInputChange(event) {
      const file = event.target.files[0];
      if (file) this.handleFileChange(file);
    },
    async handleFileChange(file) {
      if (this.uploading) return;
      this.uploading = true;
      try {
        const formData = new FormData();
        formData.append('attachment', file);
        formData.append('destination_id', this.destination.gate_id || this.destination.location_id);
        formData.append('document_type', this.documentTypeValue);
        formData.append('attachable_type', 2);
        await this.$store.dispatch('indents/addV2Attachment', {
          indentNo: this.indentNo,
          formData,
        });
        this.$emit('uploaded');
      } catch (error) {
        const apiMessage = error && error.data && (error.data.message || (error.data.errors && error.data.errors[0] && error.data.errors[0].message));
        this.$errorMessage({ message: apiMessage || error.message || 'Upload failed' });
        this.$emit('close');
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
